<template>
    <div class="container">
        <div class="fixed-cards">
            <el-card shadow="hover" class="card">
                <basic-container>
                    <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page"
                        ref="crud" @search-change="searchChange" @refresh-change="refreshChange(page)"
                        @selection-change="handleSelectionChange" @size-change="pageSizeChange"
                        @row-update="handleUpdate" @current-change="pageChange">
                        <template slot-scope="scope" slot="menuLeft">
                            <el-button size="mini" type="danger" @click="handleDel(scope.row)" icon="el-icon-delete">
                                删除
                            </el-button>
                        </template>
                        <template slot-scope="scope" slot="menu">
                            <el-button size="mini" type="danger" @click="handleDel(scope.row)" icon="el-icon-delete">
                                删除
                            </el-button>
                        </template>
                        <template slot-scope="scope" slot="picUrl">
                            <viewer :images="formmaterImage(scope.row.picUrl)">
                                <img v-for="src in formmaterImage(scope.row.picUrl)" :src="src" :key="src" width="20">
                            </viewer>
                        </template>
                    </avue-crud>
                </basic-container>
            </el-card>
        </div>
    </div>
</template>
<script>
import { getGoodsDetailList, increaseGoods, delDetailGoods } from "@/api/salesCloud/warehouse";
import { warehouseGoodsDetailOption } from "@/const/salesCloud/warehouseGoodsDetailOption";
export default {
    name: "warehouseDetails",
    data() {
        return {
            tableOption: warehouseGoodsDetailOption, //表格设置属性
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            loading: false,
            ids: "",
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10 //每页显示多少条
            },
        };
    },
    created() {
        this.getGoodsDetailList();
    },
    methods: {
        formmaterImage(row) {
            let str = new Array();
            JSON.stringify(row);
            if (row != null) {
                let picArray = row.split(",");
                for (let i = 0; i < picArray.length; i++) {
                    str.push(picArray[i]);
                }
            }
            return str;
        },
        clean() {
            this.point = {};
            this.department = "";
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = this.page.currentPage;
            params.size = pageSize;
            params.goodsId = this.$route.query.goodsId;
            params.warehouseId = this.$route.query.warehouseId;
            this.downloadData = params;
            getGoodsDetailList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                console.log("表格数据：", this.tableData);
                
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            this.downloadData = params;
            params.goodsId = this.$route.query.goodsId;
            params.warehouseId = this.$route.query.warehouseId;
            getGoodsDetailList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            params.goodsId = this.$route.query.goodsId;
            params.warehouseId = this.$route.query.warehouseId;
            getGoodsDetailList(params).then(res => {
                if (res.code != 500) {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.tableData = [];
                }
            });
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            this.downloadData = params;
            params.goodsId = this.$route.query.goodsId;
            params.warehouseId = this.$route.query.warehouseId;
            getGoodsDetailList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize
                };
                this.tableLoading = false;
            });
        },
        /**
             * @title 打开入库窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
        handleAdd() {
            this.dialogVisible = true;
        },
        AddIncrease(id) {
            this.dialogVisibleIncrease = true;
            this.formIncrease.items[0].goodsId = id;
        },
        cancelFormIncrease() {
            this.dialogVisibleIncrease = false;
            this.formIncrease.items = [{ num: '', warehouseId: this.$route.query.warehouseId, goodsId: '', type: "INCREASE" }];
        },
        // 更新已选商品的数组
        updateSelectedGoods() {
            this.selectedGoods = this.form.items.map((item) => item.goodsId).filter(Boolean);
        },
        // 判断商品是否已被选择，排除当前行的商品
        isGoodsSelected(goodsId, currentGoodsId) {
            return this.selectedGoods.includes(goodsId) && goodsId !== currentGoodsId;
        },
        addFormItem() {
            if (this.selectedGoods.length === this.goodsList.length || this.form.items.length >= this.goodsList.length) {
                this.$message({
                    showClose: true,
                    message: "不能再添加商品了",
                    type: "warning"
                });
                return;
            }
            this.form.items.push({ num: '', warehouseId: this.$route.query.warehouseId, goodsId: '', type: "INCREASE" });
        },
        delFormItem(index) {
            this.form.items.splice(index, 1);
            this.updateSelectedGoods();
        },
        cancelForm() {
            this.dialogVisible = false;
            this.form.items = [{ num: '', warehouseId: this.$route.query.warehouseId, goodsId: '', type: "INCREASE" }];
        },
        submitForm() {
            let params = this.form.items;
            increaseGoods(params).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "入库成功",
                        type: "success"
                    });
                    // 重置表单
                    this.form.items = [{ num: '', warehouseId: this.$route.query.warehouseId, goodsId: '', type: "INCREASE" }];
                    this.dialogVisible = false;
                    this.getGoodsDetailList();
                } else {
                    setTimeout(() => {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : '入库失败,请重试',
                            type: "error"
                        });
                    }, 1000)

                }
            });

        },
        submitIncreaseForm() {
            let params = this.formIncrease.items;
            increaseGoods(params).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "入库成功",
                        type: "success"
                    });
                    // 重置表单
                    this.formIncrease.items = [{ num: '', warehouseId: this.$route.query.warehouseId, goodsId: '', type: "INCREASE" }];
                    this.dialogVisibleIncrease = false;
                    this.getGoodsDetailList();
                } else {
                    setTimeout(() => {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : '入库失败,请重试',
                            type: "error"
                        });
                    }, 1000)
                }
            });
        },
        handleEdit(row, index) {
            this.clean();
            this.$refs.crud.rowEdit(row, index);
            this.department = {
                id: row.shopId,
                shopName: row.shopName
            };
            this.point = {
                address: row.address,
                location: {
                    lng: row.longitude,
                    lat: row.latitude
                }
            };
        },
        handleUpdate(form, index, done, loading) {
            let params = {
                ...form,
                id: form.id,
                shopId: this.department.id,
                warehouseGoodsName: form.warehouseGoodsName,
                warehouseGoodsMobile: form.warehouseGoodsMobile,
                address: this.point.address,
                longitude: this.point.location.lng,
                latitude: this.point.location.lat,
            };
            const isEdit = true;
            increaseGoods(params, isEdit).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success"
                    });
                    done();
                    this.getGoodsDetailList();
                } else {
                    setTimeout(() => {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : '编辑失败,请重试',
                            type: "error"
                        });
                        loading();
                    }, 1000)
                }
            });
        },
        handleView(id) {
            //跳转到详情页面查看
            this.$router.push({
                path: "/salesCloud/warehouse/goosDetailsView",
                query: {
                    id,
                },
            });
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange(val) {
            let ids = val.map(item => {
                return item.id;
            });
            this.ids = ids.join(",");
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(row) {
            let ids = "";
            ids = this.ids;
            if (row) {
                ids = row.id;
                this.$confirm(`您确定删除该条数据吗？`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        delDetailGoods(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功删除",
                                        type: "success"
                                    });
                                    this.getGoodsDetailList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message ? res.message : '删除失败,请重试',
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            } else {
                if (!ids) {
                    this.$message({
                        showClose: true,
                        message: "未选中任何数据",
                        type: "error"
                    });
                    return;
                }
                let length = ids.split(",").length;
                this.$confirm(
                    `共选中${length}条数据吗，您确定批量删除吗？`,
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                    .then(() => {
                        delDetailGoods(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功",
                                        type: "success"
                                    });
                                    this.getGoodsDetailList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            }
        },
        getGoodsDetailList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize,
                goodsId: this.$route.query.goodsId,
                warehouseId: this.$route.query.warehouseId
            };
            this.downloadData = params;
            getGoodsDetailList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                console.log('this.tableData::: ', this.tableData);
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
        },
        /* findPureWaterGoodsByRootDepartId() {
            findPureWaterGoodsByRootDepartId().then((res) => {
                let data = JSON.parse(res.data);
                if (data == null) {
                    this.goodsList = [];
                } else {
                    this.goodsList = data;
                }
            });
        }, */
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px;
    min-height: 80%;
    box-sizing: border-box;
    font-family: fangsong;
    font-size: large;
}

.fixed-cards {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
}

.card {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-content {
    padding: 20px;
}

/* 确保表格的字体与其他部分一致 */
.el-table {
    font-family: fangsong;
    font-weight: bold;
    font-size: large;
}

.el-table th,
.el-table td {
    font-family: fangsong;
    font-size: large;
}

.el-table th {
    font-family: fangsong;
    font-size: large;
}
</style>
